
import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import * as ts from "typescript";
import { FormulaList } from '../forms/formula-tester/formula-tester-action/formula-tester-action.component';
import { Variable } from '../forms/formula-tester/formula-tester.component';


@Injectable({
  providedIn: 'root'
})
export class FormulaTSService {
  context: any;

  constructor() { }
  form:AbstractControl | UntypedFormGroup;
  param:Map<string,any>;
  private formulaList:FormulaList[]=
  [
    {
      name:"mostrarErro",
      description: "Mostrar Mensagem de Erro",
      sintaxe: {
        expression:"this.mostrarErro",
        parameters:['Mensagem'],
        types:['S']
      }
  },
  {
      name:"atualizarCampo",
      description: "Marca o campo como usado pelo usuário.",
      sintaxe: {
        expression:"this.atualizarCampo",
        parameters:['Mensagem'],
        types:['S']
      }
  },
  {
    name:"getValue",
    description: "Busca Valor de um Campo",
    sintaxe: {
      expression:"this.getValue",
      parameters:['Campo'],
      types:['S']
    }
  },
  {
    name:"disable",
    description: "Desabilitar um Campo",
    sintaxe: {
      expression:"this.disable",
      parameters:['Campo'],
      types:['S']
    }
  },
  {
    name:"enable",
    description: "Habilitar um Campo",
    sintaxe: {
      expression:"this.enable",
      parameters:['Campo'],
      types:['S']
    }
  },
  {
    name:"required",
    description: "Tornar Obrigatório",
    sintaxe: {
      expression:"this.required",
      parameters:['Campo'],
      types:['S']
    }
  },
  {
    name:"nonRequired",
    description: "Tirar Obrigatoriedade",
    sintaxe: {
      expression:"this.nonRequired",
      parameters:['Campo'],
      types:['S']
    }
  },
  {
    name:"setValue",
    description: "Setar um valor de um campo",
    sintaxe: {
      expression:"this.setvalue",
      parameters:['Campo','Valor'],
      types:['S','O']
    }
  },
  {
    name:"minValue",
    description: "Definir quantidade mínima de caracteres",
    sintaxe: {
      expression:"this.minValue",
      parameters:['Campo','Quantidade'],
      types:['S','N']
    }
  },
  {
    name:"maxValue",
    description: "Definir quantidade máxima de caracteres",
    sintaxe: {
      expression:"this.maxValue",
      parameters:['Campo','Quantidade'],
      types:['S','N']
    }
  }
]
  
  get formulas(){
    this.formulaList = this.formulaList.sort((a,b)=>{
        if ( a.name > b.name ){
          return 1;
        }
        if ( a.name < b.name ){
          return -1;
        }
        return 0;
    });
    return this.formulaList;
  }

  calculate(expression:string, param:Map<string,any>){
    this.param = param;
    return eval(expression)
  }

  
  execute(expression:string, param:Map<string,any>, form:AbstractControl | UntypedFormGroup, context:any =null){
    try{
      if ( context ==null ){
      'use strict';
      }
      this.form = form;
      this.param = param;
      if ( context != null){
        this.context = context;
      }
      
      return eval(expression);
    }catch(Error){
      console.error("Error executing formula:", expression, "with parameters:", param, "and form:", form, "Error:", Error);
      throw Error;
    }
    
  }

  mostrarErro(message){
    throw Error(message);
  }

  atualizarCampo(field:string){
      if ( this.form == null ){
        return;
      }
      this.form.get(field).updateValueAndValidity();
  }

  disable(field:string){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).disable();
  }

  enable(field:string){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).enable();
  }

  remove(field:string){
    if ( this.form == null ){
      return;
    }
    if (this.form instanceof UntypedFormGroup) {
      this.form.removeControl(field);
    }
  }

  required(field:string){
    if ( this.form == null ){
      return;
    }

    this.form.get(field).addValidators(Validators.required);
  }

  nonRequired(field:string){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).removeValidators(Validators.required);
  }

  setValue(field:string,value:string){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).setValue(value);
  }

  getValue(field:string){
    if ( this.form == null ){
      return this.param.get(field);
    }else{  
      return this.form.get(field).value;
    }
    
  }

  minValue(field:string,value:number){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).setValue(Validators.minLength(value));
  }

  maxValue(field:string,value:number){
    if ( this.form == null ){
      return;
    }
    this.form.get(field).setValue(Validators.minLength(value));
  }

  toMap(data: UntypedFormGroup|Object|Array<Variable>|UntypedFormControl, param:Map<string,any>){
    if (data instanceof Array){
        data.forEach((d:Variable)=>{
          param.set(d.key,d.value);
        });
    }else{
      if (data instanceof UntypedFormGroup){
        Object.keys(data.controls).forEach(control=>{
            const abstractControl = data.controls[control];
            param.set(control,abstractControl.value);
        });
      }else{
          if ( typeof(data)=='string' || typeof(data)=='number' ){
            param.set("value",data);
          }else{
            Object.keys(data).forEach(ob=>{
              param.set(ob,data[ob]);
            });
          }
      }
    }
    
  }

}
